module.exports = new __parcel__URL__("change-boarding.5aa6a3c0.svg").toString();